import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_SEARCH_PLATFORM = `${URL_RETAILER_SCOPED}/search-platform`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'search-platform'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'search-platform': URL_SEARCH_PLATFORM,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
